import { Dropcursor } from "@tiptap/extension-dropcursor";
import { Image } from "@tiptap/extension-image";
import { Placeholder } from "@tiptap/extension-placeholder";
import { Underline } from "@tiptap/extension-underline";
import {
  generateHTML,
  generateJSON,
  Mark,
  mergeAttributes,
} from "@tiptap/react";
import { StarterKit } from "@tiptap/starter-kit";
import theme from "../styles/colors";
import { Superscript } from "@tiptap/extension-superscript";
import { Subscript } from "@tiptap/extension-subscript";
import { Strike } from "@tiptap/extension-strike";
const CustomImage = Image.extend({
  name: "image",
  group: "block",
  inline: false,
  draggable: true,
  // defaultOptions: {
  //   caption: true,
  // },
  addAttributes() {
    return {
      src: {},
      alt: { default: null },
      caption: { default: "" },
    };
  },
  renderHTML({ HTMLAttributes, node }) {
    const style = {
      container: `
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        border: 2px solid rgb(${theme.colors.neutral150});
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        margin: 16px 0px;
      `,
      imageWrapper: `
        aspect-ratio: 2 / 1;
        // border-radius: 12px;
        overflow: hidden;
      `,
      image: `
        background-image: url(${HTMLAttributes.src
          .replaceAll("(", "%28")
          .replaceAll(")", "%29")});
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        position: relative;
        background-color: rgb(${theme.colors.offWhite});
      `,
      overlay: `
        background-color: rgba(${theme.colors.neutral100}, 0.2);
        backdrop-filter: blur(32px);
        position: absolute;
        inset: 0;
        background-image: inherit;
        background-size: cover;
        filter: blur(32px);
        transform: scale(1.2);
      `,
      textContainer: `
        background: rgb(${theme.colors.lgtGrey});
        padding: 12px;
        height: auto;
      `,
      text: `
        font-family: Inter;
        font-size: 17px;
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0em;
        text-align: left;
        color: rgb(${theme.colors.neutral200});
      `,
    };

    // HTMLAttributes.caption = 'test';

    return [
      "div",
      mergeAttributes({ style: style.container }),
      [
        "div",
        mergeAttributes({ style: style.imageWrapper }),
        [
          "div",
          mergeAttributes(HTMLAttributes, { style: style.image }),
          ["div", mergeAttributes({ style: style.overlay })],
          [
            "div",
            mergeAttributes(HTMLAttributes, {
              style: `background-image: url(${HTMLAttributes.src
                .replaceAll("(", "%28")
                .replaceAll(")", "%29")});
              background-position: center;
              background-size: contain;
              background-repeat: no-repeat;
              position: absolute;
              display: block;
              inset: 0;
              border-bottom: ${
                HTMLAttributes.caption
                  ? `2px solid rgb(${theme.colors.neutral150})`
                  : ""
              };
              `,
            }),
          ],
        ],
        "",
      ],
      HTMLAttributes.caption && [
        "div",
        mergeAttributes({ style: style.textContainer }),
        [
          "span",
          mergeAttributes({ style: style.text }),
          HTMLAttributes.caption,
        ],
      ],
    ];
  },
});

const Collaborative = Mark.create({
  name: "collaborative",
  parseHTML: () => {
    return [
      {
        tag: "span",
      },
    ];
  },
  addAttributes() {
    return {
      "data-authorId": {
        parseHTML: (element) => {
          const classList = [];
          for (const cls of element.classList.entries()) {
            const [key, value] = cls;
            if (value.includes("a_") || value.includes("anonymous"))
              classList.push(value);
          }
          return classList.length ? classList.join(" ") : null;
        },
      },
      title: {
        parseHTML: (element) => {
          return element.getAttribute("title") ?? null;
        },
      },
    };
  },
  renderHTML: ({ HTMLAttributes }) => {
    return ["span", mergeAttributes(HTMLAttributes)];
  },
});

export const useTipTap = () => {
  const extensions = [
    Collaborative,
    StarterKit,
    // CustomNode,
    Dropcursor,
    Underline,
    CustomImage.configure({
      HTMLAttributes: {
        class: "image-custom-class",
      },
    }),
    Placeholder.configure({
      placeholder: "Jot a note, a few words, or the beginning of a chapter...",
    }),
    Superscript,
    Subscript,
    Strike,
  ];

  const getHtml = (jsonDoc) => {
    return generateHTML(jsonDoc, extensions);
  };

  const getJson = (htmlString) => {
    return generateJSON(htmlString, extensions);
  };
  return {
    extensions,
    getHtml,
    getJson,
  };
};
